(function ($) {
    var mobileClass = 'mobile-toggle';
    var $elDisplay = $('[data-privacy-display]');
    if($elDisplay.length > 0) {
        var $elAccept = $('[data-privacy-accept]');
        var $elDelete = $('[data-privacy-delete]');
        if($elAccept.length > 0) {
            var cookies = [];
            var allAgreed = true;
            for (var i = 0; i < $elAccept.length; i++) {
                cookies[$($elAccept[i]).data('id')] = readCookie($($elAccept[i]).data('id'));
            }
            for (var name in cookies) {
                if(cookies[name] === 'true') {
                    toggleVisibility($('[data-privacy-display="' + name + '"]'));
                } else {
                    allAgreed = false;
                }
            }
            if(allAgreed) {
                toggleVisibility($elDisplay);
            }
            $elAccept.on('click', function() {
                closeMobile($(this).closest('.isaca-consent-privacy'), mobileClass);
                createCookie($(this).data('id'), 'true', $(this).data('cookie-policy-expiration'));
                toggleVisibility($('[data-privacy-display="' + $(this).data('id') + '"]'));
            });
        } else {
            toggleVisibility($elDisplay);
        }

        // For Testing
        if($elDelete.length > 0) {
            $elDelete.on('click', function() {
                eraseCookie($(this).data('id'));
            });
        }

        var $elToggleMobile = $('[data-privacy-details]');
        $elToggleMobile.on('click', function() {
            if(!$(this).closest('.isaca-consent-privacy').hasClass(mobileClass)) {
                $(this).addClass(mobileClass);
                $(this).closest('.isaca-consent-privacy').addClass(mobileClass);
                $($(this).data('parent')).addClass(mobileClass);
                $($(this).data('target')).addClass(mobileClass);
            } else {
                if($(this).hasClass(mobileClass)) {
                    $(this).removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').removeClass(mobileClass);
                    $($(this).data('parent')).removeClass(mobileClass);
                    $($(this).data('target')).removeClass(mobileClass);
                } else {
                    $(this).closest('.isaca-consent-privacy').find('.privacy-col').removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').find('.isaca-consent-text-toggle').removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').find('.isaca-consent-text').removeClass(mobileClass);
                    $(this).addClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').addClass(mobileClass);
                    $($(this).data('parent')).addClass(mobileClass);
                    $($(this).data('target')).addClass(mobileClass);
                }
            }
        });
        var $elToggleMobileClose = $('[data-privacy-details-close]');
        $elToggleMobileClose.on('click', function() {
            closeMobile($(this).closest('.isaca-consent-privacy'), mobileClass);
        });
    }
}(jQuery));

function toggleVisibility($el) {
    $el.remove();
}

function createCookie(name, value, days) {
    var expires = '';
    if(days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + ';secure';
}

function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if(c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, '', -1);
}

function closeMobile($container, mobileClass) {
    $container.removeClass(mobileClass);
    $container.find('.privacy-col').removeClass(mobileClass);
    $container.find('.isaca-consent-text-toggle').removeClass(mobileClass);
    $container.find('.isaca-consent-text').removeClass(mobileClass);
}



// WEBPACK FOOTER //
// ./src/app/components/privacy-policy/privacy-policy.js